export default __webpack_public_path__ + "static/Students.pl_logo-ad6dcdf02ebb7daab15b7804ab8ad4db.png";